export default "__VITE_ASSET__Bmyxulgr__"